"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldLabel = void 0;
var field_label_1 = require("./field-label");
Object.defineProperty(exports, "FieldLabel", { enumerable: true, get: function () { return field_label_1.FieldLabel; } });
//# sourceMappingURL=index.js.map